import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgBottleFill} from "~/assets/svg/bottle-fill.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmBottleFillIcon: React.FC<IIconBase> = ({
  id,
  size = "sm",
  color = designColors.black,
  strokeWidth = "initial",
  className,
}) => {
  return (
    <SvgBottleFill
      id={id}
      className={cx(
        simpleIconStyles(size),
        commonStyles.strokeColor(color),
        commonStyles.strokeWidth(strokeWidth),
        className,
      )}
    />
  );
};
